'use client';

import { __makeTemplateObject } from '../_virtual/_tslib.js';
import React__default from 'react';
import styled from 'styled-components';

var RibbonTagWrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    position: absolute;\n    top: 0;\n    right: 16px;\n    pointer-events: none;\n    label {\n        position: absolute;\n        bottom: 12px;\n        left: 0;\n        color: #fff;\n        font-weight: 700;\n        line-height: 14px;\n        font-size: 10px;\n        text-align: center;\n        width: 100%;\n        margin: 0;\n    }\n"], ["\n    position: absolute;\n    top: 0;\n    right: 16px;\n    pointer-events: none;\n    label {\n        position: absolute;\n        bottom: 12px;\n        left: 0;\n        color: #fff;\n        font-weight: 700;\n        line-height: 14px;\n        font-size: 10px;\n        text-align: center;\n        width: 100%;\n        margin: 0;\n    }\n"])));
var RibbonTag = function (props) {
    var _a = props.color, color = _a === void 0 ? '#005AFF' : _a, _b = props.children, children = _b === void 0 ? '' : _b;
    return (React__default.createElement(RibbonTagWrapper, null,
        React__default.createElement("svg", { xmlns: 'http://www.w3.org/2000/svg', width: '29', height: '39', viewBox: '0 0 29 39', fill: 'none' },
            React__default.createElement("path", { d: 'M0 0H29V39L14.5 33L0 39V0Z', fill: color })),
        React__default.createElement("label", null, children)));
};
var templateObject_1;

export { RibbonTag as default };
//# sourceMappingURL=RibbonTag.js.map
